
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Cell from 'vux/src/components/cell/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import global from "../../../static/js/global.js";
import loadPage from "../../components/loadingPage";
import $ from "jquery";
import XInput from "vux/src/components/x-input/index";
export default {
components: {
XInput,
PopupPicker,
Group,
Cell,
XButton,
Flexbox,
FlexboxItem,
Alert,
Confirm,
loadPage,
$
},
data() {
return {
showConfirm:false,
feeLateFlag:false,
calcFeeLate: 0, // 计算违约金
selectDate: [[], []],
selectedDate: [],
houseinfo: "",
detailData: [],
balance: "",
balancebackup: "",
totalFee: "",
totalFeebackup: "",
addCondition: true,
comnCode: "",
hs_no: "",
zhstatus: "",
submitable: false,
paydate: [],
paysum: "",
/*赠送月份*/
giving: "",
show: false,
showprompt: false,
billCode: "",
prompt: "",
begin: "",
end: "",
offset: "",
PreferentialTerms: [],
showLog: false,
mList: [],
ndList: [],
msrue1: false,
msrue: false,
feeShow: false,
comdes: "",
housePlace: "",

/*可以做优化，做法：仅定义2个字段*/
plain3: false,
plain6: false,
plain12: false,
plain121: false,
plain243: false,
isshowBtn: true,
yhPlus: "",
format: function(value) {
return dateFormat(
new Date(value[0], parseInt(value[1]) - 1, 1),
"YYYY-MM"
);
}
};
},
beforeMount() {
this.show_1 = true;
this.getInitSelectDate();
let url = global.host + "pay/findhouse?openid=" + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
this.$http.get(url).then(
function(res) {
for (let i = 0; i < res.body.paymentdetail.length; i++) {
this.calcFeeLate += res.body.paymentdetail[i].calcFeeLate;
}
if(this.calcFeeLate > 0){
this.feeLateFlag = true;
}
this.show_1 = false;
this.housePlace = res.body.housearea + "㎡";
this.houseinfo = res.body.comnName + " " + res.body.houseCode;
this.comnCode = res.body.comnCode;
this.hs_no = res.body.houseCode;
this.hsName = res.body.hsName;
this.paydate = res.body.paydate;
this.begin = res.body.starttime;
let threemonth = dateFormat(
new Date(
this.begin.split("-")[0],
this.begin.split("-")[1] * 1 + 1,
this.begin.split("-")[2]
),
"YYYY-MM-DD"
).toString();
if (threemonth == this.end) {
$(".am_ulist li:first")
.find("button")
.addClass("am_persfors");

} else {
$(".am_ulist li:first")
.find("button")
.removeClass("am_persfors");

}
this.end = res.body.endtime;
if (res.body.code == 120) {
this.prompt = "费用未生成，请联系物业处理！!";
this.showprompt = true;
} else if (res.body.code == 130) {
this.prompt = res.body.feetypes;
this.showprompt = true;
} else if (res.body.code == 140) {
this.prompt = res.body.nofeedata;
this.showprompt = true;
} else {
this.balance = res.body.zhmoney;
this.balancebackup = res.body.zhmoney;
this.totalFee = res.body.sumpayment;
this.totalFeebackup = res.body.sumpayment;
let endDate = this.$router.history.current.query.endDate;
if (endDate) {
let formatDate = endDate.split("-");
this.selectedDate.push(formatDate[0]);
this.selectedDate.push(parseInt(formatDate[1]));
} else {
let formatDate = res.body.endtime.split("-");
this.selectedDate.push(formatDate[0]);
this.selectedDate.push(parseInt(formatDate[1]));
}

this.zhstatus = res.body.zhstatus;
if (this.begin == this.end) {
this.submitable = true;
}

/*let orderInfo = res.body.paymentdetail;
for(let i = 0 ; i < orderInfo.length; i++){
orderInfo[i].startTime = dateFormat(new Date(orderInfo[i].starttime),'YYYY/MM')
orderInfo[i].endTime = dateFormat(new Date(res.body.endtime),'YYYY/MM')
if(orderInfo[i].youhui){
this.isshowBtn = false;
}
this.detailData.push(orderInfo[i]);
}*/
}
this.getDiscount();

},
function(err) {
console.log(err);
}
);


/*let urlt = global.host + 'pay/findhouse?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone
this.$http.get(urlt).then(function(res){
let gNum = res.body.paymentdetail;
for(let itm in gNum){
this.mList[itm] = gNum[itm];
}
},function(err){
console.log(err)
})*/
},
mounted() {
if (this.$router.history.current.path == "/pay/tenement") {

document.title = "物业缴费";
}
$(".am_font1")
.parent(".weui-dialog__bd")
.css({ "padding-left": "0.1em", "padding-right": "0.1em" });

$(".am_ulist").delegate("li", "click", function() {
$(this)
.find("button")
.addClass("am_persfors");
$(this)
.siblings("li")
.find("button")
.removeClass("am_persfors");
});
this.msrue = true;
this.msrue1 = false;
},
methods: {
async getDiscount() {

let durl = global.host + "discountConfig/getList?comnCode=" + this.comnCode;
await this.$http.get(durl).then(
function(res) {
let mdatas = res.body.result;
this.PreferentialTerms = new Object();
for (let item in mdatas) {
this.PreferentialTerms[item] = mdatas[item];
}
},
function(err) {
console.log(err);
}
);
},
serchDetail() {

this.showLog = true;
},
cancel() {
this.submitable = false;
},
/*根据不同的操作进行操作*/
refresh() {
if (this.prompt == "支付成功") {
this.submitable = true;
this.$router.push({
path: "/pay/tenement",
query: {
openid: this.$router.history.current.query.openid,
phone: this.$router.history.current.query.phone
}
});
} else if (this.prompt == "您有未处理的订单,请优先处理") {
this.submitable = true;
this.$router.push({
path: "/paymentRecord",
query: {
openid: this.$router.history.current.query.openid,
phone: this.$router.history.current.query.phone
}
});
} else if (this.prompt.indexOf("费用未生成") > -1) {
this.show = false;
this.submitable = true;
} else if (this.prompt == "当前小区费用类型不存在!") {
this.show = false;
this.submitable = true;
} else if (this.prompt == "费用没有生成!") {
this.show = false;
this.submitable = true;
} else if (this.prompt.indexOf("您所欠缴的费用已产生违约金") > -1) {
this.show = false;
this.submitable = true;
} else {
this.show = true;
this.submitable = false;
}
},
/*去支付方法*/
gopay() {
this.submitable = true;
/*数据准备*/
let senddata = new Object();
senddata.comnCode = this.comnCode;
/*不调用微信接口去支付*/
if (this.totalFee == 0) {
senddata.accoubalance = this.balance;
if (!this.addCondition) {
senddata.flag = 0; /*启用*/
} else {
senddata.flag = 1; /*禁用*/
}
senddata.flag = 1;
senddata.billCode = this.billCode;
senddata.giving = this.giving;
senddata.houseNo = this.hs_no;
senddata.payMonth = this.paydate;
senddata.paysum = this.paysum;
senddata.hsName = this.hsName;
let url = global.host + "pay/payproperorder";
this.$http.post(url, senddata).then(
function(res) {
this.showprompt = true;
if (res.body.code == 120) {
this.prompt = "支付失败";
} else if (res.body.code == 110) {
this.prompt = "支付成功";
}
},
function(err) {
console.log(err);
}
);
} else {
/*调用微信接口去支付*/
senddata.memberNo = this.$router.history.current.query.phone;
senddata.openid = this.$router.history.current.query.openid;
senddata.tradeAmount = this.totalFee;
senddata.tradeNo = this.billCode;
senddata.tradeName = "物业费";
senddata.tradeDesc = "物业费(包括电梯费、生活垃圾费)";
let url = global.host + "pay/getpayurl";
this.$http.post(url, senddata).then(
function(res) {
if (res.body.code == "110") {
location.href = res.body.payurl;
} else {
this.prompt = "支付异常,请稍候再试";
this.submitable = false;
this.showprompt = true;
}
},
function(err) {
console.log(err);
}
);
}
},
/*提交订单之前的操作*/
submitBefore() {
this.submitable = true;
this.$http
.get(
global.host +
"pay/findownerunpaidorder?comnCode=" +
this.comnCode +
"&houseNo=" +
this.hs_no +
"&openid=" +
this.$router.history.current.query.openid +
"&phoneNo=" +
this.$router.history.current.query.phone
)
.then(
function(res) {
if (res.body.code == "110") {
this.submitable = false;
this.submit();
} else if (res.body.code == "120") {
this.prompt = "您有未处理的订单,请优先处理";
this.showprompt = true;
}
},
function(err) {
console.log(err);
}
);
},
/*提交订单*/
submit() {
this.show_1 = true;
console.log("计算违约金"+this.calcFeeLate);
if(!this.feeLateFlag){
let totalYH = 0,
totalfeeLate = 0,
totalYouHui = 0;
let givyouhuisum = this.yhPlus;
for (let i = 0; i < this.detailData.length; i++) {
totalYH = this.detailData[i].yingshou * 1 + totalYH;
totalfeeLate = this.detailData[i].feeLate * 1 + totalfeeLate;
totalYouHui = this.detailData[i].youhui * 1 + totalYouHui;
}
totalYouHui = totalYouHui + givyouhuisum;
console.log("%%%%%%%%%%%%%%%%%%%");
console.log(totalYouHui);
let senddata = new Object();
senddata.comnCode = this.comnCode;
senddata.houseNo = this.hs_no;
senddata.hsName = this.hsName;
senddata.shishou = this.totalFeebackup;
senddata.yingshou = totalYH + givyouhuisum;
senddata.startDate = this.begin;
senddata.endDate = this.end;
senddata.giving = this.giving;
senddata.openid = this.$router.history.current.query.openid;
senddata.memberNo = this.$router.history.current.query.phone;
if (totalYouHui) {
senddata.youhui = totalYouHui;
}
if (totalfeeLate) {
senddata.feeLate = totalfeeLate;
}
if (this.zhstatus == 1) {
senddata.accoubalance = this.balancebackup;
}
/*冲抵暂且不做*/





senddata.flag = 1; /*禁用*/

let url = global.host + "pay/subproperorder";
this.$http.post(url, senddata).then(
function(res) {
this.show_1 = false;
if (res.body.code == "110") {
this.show = true;
this.billCode = res.body.tradeNo;
}
},
function(err) {
this.show_1 = false;
console.log(err);
}
);

} else {
this.show_1 = false;
this.prompt = "您所欠缴的费用已产生违约金，如需缴费请计算应缴违约金";
this.showConfirm = true;
}

},
/*设置缴费时长*/
setPayTime(time, giving) {
console.log("$$$");
console.log(giving);
let backupdate = this.paydate;
console.log(backupdate);
let temp = parseInt(backupdate.split("-")[1]);
this.selectedDate.pop();
this.selectedDate.pop();
this.selectedDate.push(parseInt(backupdate.split("-")[0]));
this.selectedDate.push(temp + time * 1);
this.paysum = time;


this["plain" + time + (giving ? giving : "")] = true;
this.giving = giving ? giving : "";
this.getDetail(time, giving);
},
/*初始化时间选择*/
getInitSelectDate() {
let date = new Date();
date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
this.selectDate[0].push(date.getFullYear());
this.selectDate[0].push(date.getFullYear() + 1);
this.selectDate[0].push(date.getFullYear() + 2);
let curM = date.getMonth() + 1;
this.selectDate[1] = new Array();
for (let i = curM; i < 13; i++) {
this.selectDate[1].push(i);
}
},
/*获取订单的信息信息*/
getDetail(time, giving) {
this.show_1 = true;
this.msrue = false;
this.msrue1 = true;
console.error(this.paydate+":"+time);
giving = giving ? giving : "";
let url = global.host + "pay/findpayment";
this.$http
.post(url, {
payMonth: this.paydate,
paysum: time,
giving: giving,
houseNo: this.hs_no,
comnCode: this.comnCode
})
.then(
function(res) {
this.ndList = [];
this.show_1 = false;
let ndNum = res.body.paymentdetail;
this.yhPlus = Number(res.body.givyouhuisum);
for (let itm in ndNum) {
console.log(ndNum[itm]);
this.ndList[itm] = ndNum[itm];
}
if (res.body.code == 120) {
this.prompt = "费用未生成，请联系物业处理！";
this.showprompt = true;
} else if (res.body.code == 130) {
this.prompt = res.body.feetypes;
this.showprompt = true;
} else if (res.body.code == 140) {
this.prompt = res.body.nofeedata;
this.showprompt = true;
} else {
this.zhstatus = res.body.zhstatus;
let orderInfo = res.body.paymentdetail;
let size = this.detailData.length;
this.balance = res.body.zhmoney;
this.totalFee = res.body.sumpayment;
this.totalFeebackup = res.body.sumpayment;
this.begin = res.body.startdate;
this.end = res.body.enddate;
for (let j = 0; j < size; j++) {
this.detailData.pop();
}

if (orderInfo == null) {
this.show_1 = false;
return false;
} else {
for (let i = 0; i < orderInfo.length; i++) {
orderInfo[i].startTime = dateFormat(
new Date(orderInfo[i].startDate),
"YYYY/MM"
);
orderInfo[i].endTime = dateFormat(
new Date(orderInfo[i].endDate),
"YYYY/MM"
);
this.detailData.push(orderInfo[i]);
}
}

let data1 = orderInfo[0].endDate;
let data2 = $("#mlists").find(".vux-cell-value").html();
let mdata1 = dateFormat(new Date(data1),'YYYY/MM')
let mdata2 = dateFormat(new Date(data2),'YYYY/MM');
if(mdata2 > mdata1){
this.show_1 = false;
let dateStr = mdata1.split("/");
this.prompt = "当前只能缴纳"+dateStr[0]+"年"+dateStr[1]+"月之前的费用，如需办理请到物业缴费，谢谢！";
this.feeShow = true;
this.submitable = true;
return false;
}

this.submitable = false;
}

},
function(err) {
alert(err);
}
);
},
/*获取未来的日期 3年的*/
getFutureDate(value) {
let lastDate = new Date(this.paydate);
console.log("$$$$$$$$$$$$$$$"+value[0]+"-"+value[1]);
let futureDate = new Date(value[0], value[1] - 1, 1);
let totalMonth =
(futureDate.getFullYear() - lastDate.getFullYear()) * 12 +
(futureDate.getMonth() - lastDate.getMonth());
this.paysum = totalMonth;
this.giving = "";
this.getDetail(totalMonth);
},
/*时间选择*/
updateMonth(value) {
this.clearDate(value[0]);
},
/*重新生成选择的时间*/
clearDate(value) {
let date = new Date();
date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
let yearArr = new Array();
yearArr.push(date.getFullYear());
yearArr.push(date.getFullYear() + 1);
yearArr.push(date.getFullYear() + 2);
yearArr.push(date.getFullYear() + 3);
let monthArr = new Array();
if (value == date.getFullYear()) {
let curM = date.getMonth() + 1;
for (let i = curM; i < 13; i++) {
monthArr.push(i);
}
} else {
for (let i = 1; i < 13; i++) {
monthArr.push(i);
}
}
this.selectDate = [];
this.selectDate.push(yearArr);
this.selectDate.push(monthArr);
},
/*判断是否可选 */
/*冲抵暂且不做*/
addfactor() {
if (this.zhstatus == 1) {
/*默认不抵扣*/
this.addCondition = !this.addCondition;
let temp = this.totalFeebackup * 1;
let balanceold = this.balancebackup * 1;
if (!this.addCondition) {
/*减去 小数点后有问题*/
this.totalFee = temp - balanceold >= 0 ? temp - balanceold : 0;
this.offset = temp - balanceold >= 0 ? balanceold : balanceold - temp;
this.balance = balanceold - temp >= 0 ? balanceold - temp : 0;
} else {
this.totalFee = temp;
this.offset = 0;
this.balance = balanceold;
}
}
},
/*计算违约金*/
calcFeeLateEvent(){
this.show_1 = true;
let url = global.host + "pay/updateLateFeeMoney?comnCode="+this.comnCode+"&houseNo="+this.hs_no+"&endDate="+this.end;
this.$http.get(url).then(
function(res) {
this.show_1 = false;
console.log(res.body);
this.showConfirm = false;
this.feeLateFlag = false;
this.getDetail(this.paysum, this.giving);
},function(err) {
this.show_1 = false;
alert("网络异常，请稍后重试！");
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/payComponents/tenement.vue